import { ExternalLog } from "../../externalLogging/ExternalLog";
import { PerformanceMonitoringLogLOFactory } from "../../externalLogging/factories/PerformanceMonitoringLogLOFactory";
import { PerformanceMonitoringEnvTypeEnum } from "../enum/PerformanceMonitoringEnvTypeEnum";
import { PerformanceMonitoringVO } from "../vo/PerformanceMonitoringVO";
import { EnvGlobalsHandler } from "../../basic/EnvGlobalsHandler";

import { getLogger } from "@goodgamestudios/logger";

const logger = getLogger("PerformanceMonitoringExternalLogCommand");
export class PerformanceMonitoringExternalLogCommand {

    /**
     * Call executor only for LOG_PERC% of all users.
     */
    private static readonly LOG_PERC: number = 5;

    /**
     * Flag used to allow the execution of events based on current environment.
     *
     * During the first execution this flag could be enabled:
     * - when current environment is local.
     * - when a generated random number is between the desired percentage of users.
     */
    private static ALLOW_EXECUTION: boolean = undefined;

    private _type: PerformanceMonitoringEnvTypeEnum;
    private _userLevel: number = 1;

    constructor(type: PerformanceMonitoringEnvTypeEnum) {
        this._type = type;
    }

    public performLog(vo: PerformanceMonitoringVO, performanceCategory: number): void {
        logger.debug(vo);

        if (PerformanceMonitoringExternalLogCommand.ALLOW_EXECUTION === undefined) {
            PerformanceMonitoringExternalLogCommand.ALLOW_EXECUTION = EnvGlobalsHandler.globals.isTest ?
                true : Math.random() * 100 <= PerformanceMonitoringExternalLogCommand.LOG_PERC;
        }

        if (PerformanceMonitoringExternalLogCommand.ALLOW_EXECUTION) {
            ExternalLog.logger.log(
                new PerformanceMonitoringLogLOFactory(
                    PerformanceMonitoringLogLOFactory.AVERAGE_MEASUREMENT_DATA,
                    vo,
                    this._userLevel,
                    performanceCategory,
                    this._type,
                    EnvGlobalsHandler.globals.sessionLength * 1000
                )
            );
        }
    }

    public set userLevel(value: number) {
        this._userLevel = value;
    }
}
